$(document).ready(function() {
  (function() {
    window.SomosEmpleos || (window.SomosEmpleos = {});
    window.SomosEmpleos.token = document.querySelector('meta[name="csrf-token"]').content;
  }.call(this));
});
